import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

export interface NavigationMenuItem {
  title: string;
  route?: string;
  subMenu?: NavigationMenuItem[];
  subsubMenu?: NavigationMenuItem[];
}

@Injectable({
  providedIn: 'root',
})
export class NavigationMenuStateService {
  private readonly menuItemsSubject = new BehaviorSubject<NavigationMenuItem[]>(
    [],
  );

  readonly menuItems$: Observable<NavigationMenuItem[]> =
    this.menuItemsSubject.asObservable();

  get menuItems(): NavigationMenuItem[] {
    return this.menuItemsSubject.value;
  }

  setMenuItems(menuItems: NavigationMenuItem[]): void {
    this.menuItemsSubject.next([...(menuItems ?? [])]);
  }
}
